var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "full-height bg-white" },
    [
      _c("q-card-title", { staticClass: "text-center bg-primary text-white" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("schedule")) + "\n    ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        { staticClass: "relative-position" },
        [
          _c("full-calendar", {
            ref: "fullCalendar",
            attrs: {
              defaultView: "listMonth",
              plugins: _vm.calendarPlugins,
              weekends: true,
              events: _vm.events,
              header: {
                left: "",
                center: "title",
                right: "prev next"
              },
              titleFormat: {
                month: "short",
                year: "numeric"
              },
              locales: _vm.locales,
              datesRender: _vm.datesRender,
              weekNumbers: true
            },
            on: { dateClick: _vm.dateClicked },
            nativeOn: {
              click: function($event) {
                return _vm.dateClicked.apply(null, arguments)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }